import { Loader } from 'https://cdn.pika.dev/google-maps'

console.log("Loading store locator...")

class StoreLocator extends HTMLElement {
    constructor() {
        super()

        this.unselectedIcon = "https://cdn.shopify.com/s/files/1/0241/9487/5447/files/Pointer.png?v=1759349240"
        this.selectedIcon = "https://cdn.shopify.com/s/files/1/0241/9487/5447/files/Pointer_a979baa5-d89e-4d16-bb0a-481cbcbbd873.png?v=1759349376"

        this.key = this.getAttribute('data-key')
        this.type = this.getAttribute('data-type') || '0'
        this.filter = ''
        this.init()
    }

    async getStores() {
        this.stores = []

        let url = `https://inverfin.appsinnovategroup.com/v1/store-locator?type=${this.type}`
        let res = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Basic aW52ZXJmaW46QWthaGF0YTA1'
            },
            redirect: 'manual'
        })

        let data = await res.json()

        let pages = data._meta.pageCount
        let currentPage = data._meta.currentPage

        this.stores.push(...data.storeLocators)

        for(let i=currentPage+1; i<=pages; i++) {
            let pageRes = await fetch(`${url}&page=${i}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Basic aW52ZXJmaW46QWthaGF0YTA1'
                },
                redirect: 'manual'
            })

            let pageData = await pageRes.json()

            this.stores.push(...pageData.storeLocators)
        }
    }

    async initGoogleMaps() {
        const loader = new Loader(this.key, { libraries: ['places'] })

        const google = await loader.load()
        this.mapInstance = new google.maps.Map(this.querySelector('#store-locator-map'), {
            center: { lat: -24.530816, lng: -56.40594 },
            zoom: 7,
            styles: [{
                stylers: [{
                    saturation: -100
                }]
            }],
            disableDefaultUI: true,
            zoomControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
        })

        this.markers = this.stores.map(store => {
            const marker = new google.maps.Marker({
                position: { lat: Number(store.latitude), lng: Number(store.longitude) },
                map: this.mapInstance,
                icon: { 
                    url: this.unselectedIcon,
                    scaledSize: new google.maps.Size(32, 40)
                }
            })

            marker.store = store

            marker.addListener('click', () => {
                this.selectStore(store)
            })

            return marker
        })
    }

    renderStoreList() {
        this.citySelector = this.querySelector('#StoreLocatorCitySelector')
        this.storeList = this.querySelector('#StoreLocatorStores')

        const cities = [...new Set(this.stores.map(store => store.city))].sort()
        cities.forEach((city, i) => {
            this.citySelector.insertAdjacentHTML('beforeend', `
                <input type="radio" id="StoreLocatorCity-${i+1}" name="StoreLocatorCity" value="${city}" class="!hidden" />
                <label for="StoreLocatorCity-${i+1}">${city}</label>
            `)
        })

        this.stores.forEach(store => {

            this.storeList.insertAdjacentHTML('beforeend', `
                <div class="store-locator__store" data-city="${store.city}" data-key=${store.id}>
                    <div class="store-locator__store-title">
                        <h5 class="h6">${store.name}</h5>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M16.7084 9.55833L10.8751 3.725C10.7143 3.56869 10.4824 3.51003 10.2666 3.57111C10.0509 3.63219 9.88408 3.80373 9.8291 4.02111C9.77413 4.23849 9.8393 4.46869 10.0001 4.625L14.7584 9.375H3.7334C3.38822 9.375 3.1084 9.65482 3.1084 10C3.1084 10.3452 3.38822 10.625 3.7334 10.625H14.7501L10.0001 15.375C9.88094 15.4911 9.81376 15.6503 9.81376 15.8167C9.81376 15.983 9.88094 16.1423 10.0001 16.2583C10.1149 16.3789 10.2753 16.4454 10.4417 16.4417C10.6076 16.4424 10.7668 16.3764 10.8834 16.2583L16.7167 10.425C16.9604 10.181 16.9604 9.78568 16.7167 9.54166L16.7084 9.55833Z" fill="currentColor"/>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M16.432 15.3255L11.1038 10.0002L16.432 4.7142C16.699 4.40494 16.6846 3.94084 16.3988 3.64904C16.1131 3.35723 15.6524 3.3361 15.3414 3.60053L9.99771 8.84734L4.74746 3.56131C4.44363 3.25723 3.95294 3.25723 3.64911 3.56131C3.50164 3.70857 3.41869 3.90903 3.41869 4.11815C3.41869 4.32727 3.50164 4.52773 3.64911 4.67499L8.89158 9.95317L3.56343 15.2313C3.41596 15.3786 3.33301 15.5791 3.33301 15.7882C3.33301 15.9973 3.41596 16.1978 3.56343 16.345C3.71043 16.4918 3.90944 16.5737 4.11649 16.5725C4.31975 16.5737 4.51543 16.4949 4.66177 16.3529L9.99771 11.059L15.3414 16.4391C15.4885 16.5859 15.6875 16.6678 15.8945 16.6666C16.0989 16.6657 16.2947 16.584 16.4398 16.4391C16.5862 16.2908 16.6678 16.0898 16.6663 15.8807C16.6649 15.6715 16.5805 15.4717 16.432 15.3255Z" fill="currentColor"/>
                        </svg>
                    </div>

                    <div class="store-locator__store-info">
                        <p>${store.address}</p>
                        ${store.description}
                        <p>${!!store.phone ? `Teléfono: ${store.phone}` : ''}</p>
                        <p>${!!store.mobile_phone ? `Celular: ${store.mobile_phone}` : ''}</p>
                    </div>
                </div>
            `)
        })

        this.storeListStores = Array.from(this.storeList.querySelectorAll('.store-locator__store'))
    }

    updateMapPosition(latLng, zoom = 15) {
        this.mapInstance.setOptions({ center: latLng, zoom: zoom })
    }

    selectStore(selectedStore) {
        console.log(selectedStore.latitude, selectedStore.longitude)

        this.storeListStores.forEach(store => {
            if(`${selectedStore.id}` === store.dataset.key) {
                store.classList.add('active')
                store.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
            }else {
                store.classList.remove('active')
            }
        })

        this.markers.forEach(marker => {
            if(marker.store.id === selectedStore.id) {
                marker.setIcon({
                    url: this.selectedIcon,
                    scaledSize: new google.maps.Size(32, 40)
                })
            } else {
                marker.setIcon({
                    url: this.unselectedIcon,
                    scaledSize: new google.maps.Size(32, 40)
                })
            }
        })
        this.updateMapPosition({ lat: Number(selectedStore.latitude), lng: Number(selectedStore.longitude) })
    }

    setListeners() {
        this.citySelector.addEventListener("change", (event) => {
            this.filter = event.target.value
            this.citySelector.parentElement.querySelector('summary span').innerText = !!this.filter ? this.filter : 'Selecciona una ciudad'

            let firstCityStore = this.stores.find(store => store.city === this.filter)
            if(!!firstCityStore) {
                this.updateMapPosition({ lat: Number(firstCityStore.latitude), lng: Number(firstCityStore.longitude) }, 11)
            
            }else {
                this.mapInstance.setOptions({ zoom: 7 })
            }

            this.storeListStores.forEach(store => {
                if(!!this.filter && store.hasAttribute('data-city') && store.dataset.city !== this.filter) {
                    store.classList.add('!hidden')
                    this.markers.find(marker => `${marker.store.id}` === store.dataset.key).setMap(null)

                }else {
                    store.classList.remove('!hidden')
                    this.markers.find(marker => `${marker.store.id}` === store.dataset.key).setMap(this.mapInstance)
                }
            })

            // if(!!this.filter) history.pushState(null, "", `?city=${this.filter.toLocaleLowerCase().replace(/\s+/g, '-')}`)
            // else history.pushState(null, "", location.pathname)
        })

        this.storeListStores.forEach(store => {
            store.addEventListener('click', () => {
                if(store.classList.contains('active')) {
                    store.classList.remove('active')
                    this.mapInstance.setOptions({ zoom: 7 })

                    this.markers.forEach(marker => {
                        marker.setIcon({
                            url: this.unselectedIcon,
                            scaledSize: new google.maps.Size(32, 40)
                        })
                    })

                }else {
                    const selectedStore = this.stores.find(storeObject => `${storeObject.id}` === store.dataset.key)
                    if(!!selectedStore) {
                        this.selectStore(selectedStore)
                    }
                }
            })
        })

        this.querySelector('#StoreLocatorSearchInput')?.addEventListener('input', event => {
            let searchValue = event.target.value.toLowerCase()

            this.storeListStores.forEach(store => {
                let storeTextContent = store.textContent.toLowerCase()
                
                if(!storeTextContent.includes(searchValue) && searchValue !== '') {
                    store.classList.add('!hidden')
                    this.markers.find(marker => `${marker.store.id}` === store.dataset.key).setMap(null)

                }else {
                    store.classList.remove('!hidden')
                    this.markers.find(marker => `${marker.store.id}` === store.dataset.key).setMap(this.mapInstance)
                }
            })
        })

        // if(!!location.search) {
        //     this.citySelector.querySelectorAll('[name="StoreLocatorCity"]')?.forEach(input => {
        //         if(input.value.toLowerCase().replace(/\s+/g, '-') === location.search.split('=')[1]) {
        //             input.nextElementSibling.click()
        //         }
        //     })
        // }
    }
    
    async init() {
        await this.getStores()
        await this.initGoogleMaps()
        this.renderStoreList()
        this.setListeners()
    }
}
customElements.define('store-locator', StoreLocator)